import { render, staticRenderFns } from "./linked-item-drawer-dropdown.vue?vue&type=template&id=5954f5be&"
import script from "./linked-item-drawer-dropdown.vue?vue&type=script&lang=ts&"
export * from "./linked-item-drawer-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports